// redux/actions/catalogos_config/catalogos_config.js
// Acciones genericas para los catalogos simples de Configuracion
// (avisos, tipos_agenda, despachos, forma_solicitud, medios_electronicos,
// acciones_intentadas, prestaciones_reclamadas, formas_pago, tipos_competencia).
// Todas comparten el mismo endpoint /catalogos-config/{catalogo}.
import axios from "axios";

import { PATH } from "../../utils";

const API_BASE = `${PATH}`;

const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

const authHeader = () => {
  const token = localStorage.getItem("tokenadmin") || localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * LIST (GET /catalogos-config/{catalogo})
 */
export const actionCatalogoConfigGet = (catalogo) => {
  return async () => {
    const resp = await api.get(`catalogos-config/${catalogo}`, {
      headers: { ...authHeader() },
    });
    return resp.data;
  };
};

/**
 * CREATE (POST /catalogos-config/{catalogo})
 */
export const actionCatalogoConfigCreate = (catalogo, nombre) => {
  return async () => {
    const resp = await api.post(
      `catalogos-config/${catalogo}`,
      { nombre },
      { headers: { ...authHeader() } }
    );
    return resp.data;
  };
};

/**
 * UPDATE (PATCH /catalogos-config/{catalogo}/{id})
 */
export const actionCatalogoConfigUpdate = (catalogo, id, nombre) => {
  return async () => {
    const resp = await api.patch(
      `catalogos-config/${catalogo}/${id}`,
      { nombre },
      { headers: { ...authHeader() } }
    );
    return resp.data;
  };
};

/**
 * DELETE (DELETE /catalogos-config/{catalogo}/{id}) — soft delete active=0
 */
export const actionCatalogoConfigDelete = (catalogo, id) => {
  return async () => {
    const resp = await api.delete(`catalogos-config/${catalogo}/${id}`, {
      headers: { ...authHeader() },
    });
    return resp.data;
  };
};
